// Build metadata, baked in at build time via Vite `define` (see vite.config.js).
// Renders a small muted line like: v1.0.0 · a1b2c3d
const APP_VERSION = __APP_VERSION__;
const GIT_SHA = __GIT_SHA__;
const BUILD_TIME = __BUILD_TIME__;

export default function BuildTag({ className = '' }) {
    const sha = GIT_SHA && GIT_SHA !== 'dev' ? GIT_SHA : null;
    const title = BUILD_TIME ? `Built ${BUILD_TIME}` : undefined;

    return (
        <small className={`text-white-50 ${className}`} title={title}>
            v{APP_VERSION}
            {sha && <> · {sha}</>}
        </small>
    );
}
